import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router';
import './index.css';
import { Abertura, Aprovacao } from './equipe/Abertura';
import { Configuracoes } from './equipe/Configuracoes';
import { Fila } from './equipe/Fila';
import { LayoutEquipe } from './equipe/Layout';
import { Inicio } from './paginas/Inicio';
import { NaoEncontrada } from './paginas/NaoEncontrada';
import { PaginaCliente } from './paginas/PaginaCliente';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Inicio />} />
        <Route path="/c/:token" element={<PaginaCliente />} />
        <Route path="/equipe" element={<LayoutEquipe />}>
          <Route index element={<Fila />} />
          <Route path="aberturas/:id" element={<Abertura />} />
          <Route path="aberturas/:id/aprovar" element={<Aprovacao />} />
          <Route path="configuracoes" element={<Configuracoes />} />
        </Route>
        <Route path="*" element={<NaoEncontrada />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
